module.exports = __webpack_public_path__ + "img/set-icon.a2674e06.svg";